















import { Component, Prop, Emit, Ref } from 'nuxt-property-decorator'
import { ComponentVue } from '@/base'
import { AtomTextField } from '@/components/atoms'
import { dataStore, systemParameterStore } from '@/utils/store-accessor'
import { audioDing } from '@/utils'

@Component({
  components: {}
})
export default class InputUserId extends ComponentVue {
  @Ref()
  textField!: AtomTextField

  @Prop({
    type: String,
    required: true
  })
  value!: string

  @Prop({
    type: Boolean,
    default: false
  })
  autofocus!: boolean

  @Prop({
    type: Boolean,
    default: false
  })
  error!: boolean

  @Prop({
    type: String,
    default: ''
  })
  errorMessage!: string

  @Prop({
    type: Boolean,
    default: false
  })
  disabled!: boolean

  @Prop({
    type: Boolean,
    default: false
  })
  alphaNumeral!: boolean

  @Prop({
    type: Boolean,
    default: false
  })
  determineAudio!: boolean

  @Prop({
    type: Boolean,
    default: false
  })
  blurPaddingZero!: boolean

  get mask(): string {
    if (this.alphaNumeral) {
      return systemParameterStore.userIdMaskByAlphaNumHalf
    }

    return systemParameterStore.userIdMask
  }

  focus(): void {
    this.textField.atomTextField.focus()
  }

  onInput(value: string): void {
    this.$emit('input', value)

    // 入力文字列が利用者番号最大桁数と同一の場合
    if (value.length === systemParameterStore.userIdMaxDigits) {
      this.$nextTick(this.onInputMaxDigits)
    }
  }

  // 利用者番号を確定する時に発火するイベント
  onDetermine(): void {
    if (this.value.length === 0) {
      return
    }

    if (dataStore.enabledBarcodeReaderSound && this.determineAudio) {
      audioDing()
    }

    this.$emit('determine')
  }

  @Emit('blur')
  onBlur(): void {
    if (
      this.blurPaddingZero &&
      this.value.length > 0 &&
      this.value.length < systemParameterStore.userIdMaxDigits
    ) {
      const paddingString = this.value.padStart(
        systemParameterStore.userIdMaxDigits,
        '0'
      )

      this.onInput(paddingString)
    }
  }

  @Emit('input:max-digits')
  onInputMaxDigits(): void {
    this.onDetermine()
  }

  @Emit('keydown:enter')
  onKeydownEnter(): void {}
}
